export default __webpack_public_path__ + "static/media/edilson-vieira.040fc648.webp";